// @flow
import React, { Component } from 'react';
import EventingEventCards from 'containers/list/EventingEventCards';
import EventingTemplate from 'components/eventing/EventingTemplate/EventingTemplate';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import ScrollToTop from 'components/common/ScrollToTop';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Eventing extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <EventingTemplate>
        <Helmet>
          <title>이벤트 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 이벤트들을 살펴보세요."
          />
        </Helmet>
        <EventingEventCards category={category} sort={sort} />
      </EventingTemplate>
    );
  }
}

export default Eventing;



// WEBPACK FOOTER //
// ./src/pages/Eventing.js